@if (!isShipmentListPage) {
  <div class="noShipment">
    {{ message }}
  </div>
}

@if (isShipmentListPage) {
  <div class="no-results">
    <div class="icons">
      <mat-icon [svgIcon]="icon"></mat-icon>
      <mat-icon svgIcon="icon-bg-round" class="bg"></mat-icon>
    </div>
    <h2 data-test="message">{{ message }}</h2>
  </div>
}
